import { isMonday, isWeekend, previousFriday, previousThursday, subDays, } from "date-fns";
const lastDateForCustodianData = (checkDate, hasApex) => {
    const isDateOnWeekend = isWeekend(checkDate);
    const isDateMonday = isMonday(checkDate);
    // If we're on the weekend, or a Monday, we want to look to the previous Friday for data. Otherwise, we want to look to the previous day.
    let lastDatetoLookTill = isDateOnWeekend || isDateMonday
        ? previousFriday(checkDate)
        : subDays(checkDate, 1);
    // Apex doesn't deliver friday data until the following Monday. If the date is on the weekend, we want to look to the past thursday for data.
    // This is a "hack" to fix the data until a permanent BE solution is in place.
    if (hasApex && isDateOnWeekend) {
        lastDatetoLookTill = previousThursday(checkDate);
    }
    return lastDatetoLookTill;
};
export default lastDateForCustodianData;
//# sourceMappingURL=lastDateForCustodianData.js.map